import { Component, Input } from '@angular/core';

@Component({
    selector: 'notification-icon[count]',
    templateUrl: './notification-icon.component.html',
    styleUrls: ['./notification-icon.component.scss'],
})
export class NotificationIconComponent {
    @Input() public count!: number;

    public get textX(): number {
        return 8.5;
    }

    public get textY(): number {
        return this.count < 9 ? 12.5 : 12;
    }

    public get textFontSize(): number {
        if (this.count > 99) return 8;
        if (this.count > 9) return 9;
        return 10;
    }
}
